"use strict";

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }

  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

var __generator = this && this.__generator || function (thisArg, body) {
  var _ = {
    label: 0,
    sent: function sent() {
      if (t[0] & 1) throw t[1];
      return t[1];
    },
    trys: [],
    ops: []
  },
      f,
      y,
      t,
      g;
  return g = {
    next: verb(0),
    "throw": verb(1),
    "return": verb(2)
  }, typeof Symbol === "function" && (g[Symbol.iterator] = function () {
    return this;
  }), g;

  function verb(n) {
    return function (v) {
      return step([n, v]);
    };
  }

  function step(op) {
    if (f) throw new TypeError("Generator is already executing.");

    while (_) {
      try {
        if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
        if (y = 0, t) op = [op[0] & 2, t.value];

        switch (op[0]) {
          case 0:
          case 1:
            t = op;
            break;

          case 4:
            _.label++;
            return {
              value: op[1],
              done: false
            };

          case 5:
            _.label++;
            y = op[1];
            op = [0];
            continue;

          case 7:
            op = _.ops.pop();

            _.trys.pop();

            continue;

          default:
            if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
              _ = 0;
              continue;
            }

            if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
              _.label = op[1];
              break;
            }

            if (op[0] === 6 && _.label < t[1]) {
              _.label = t[1];
              t = op;
              break;
            }

            if (t && _.label < t[2]) {
              _.label = t[2];

              _.ops.push(op);

              break;
            }

            if (t[2]) _.ops.pop();

            _.trys.pop();

            continue;
        }

        op = body.call(thisArg, _);
      } catch (e) {
        op = [6, e];
        y = 0;
      } finally {
        f = t = 0;
      }
    }

    if (op[0] & 5) throw op[1];
    return {
      value: op[0] ? op[1] : void 0,
      done: true
    };
  }
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var SounditiApi_1 = __importDefault(require("../SounditiApi"));

var Auth_1 = __importDefault(require("../Auth"));

var defaults_1 = __importDefault(require("../defaults"));

var logger_1 = __importDefault(require("../utils/logger"));

var errors_1 = require("../utils/errors");

var utils_1 = require("../utils/utils");

var logger = logger_1.default('campaign-billing');
/**
 * Provides access to the billing options
 * @class
 *
 * @param {string} [host = defaults.host] | the api host
 *
 * @category DataLayers
 *
 * @example
 * // ====== ONE TIME PAYMENTS =========
 * // PRE REQUIREMENTS (stripe checkout)
 *
 * // TEST METHOD FOR USING WITHIN A REACT COMPONENT
 * // ADD STRIPE LIB TO REACT
 *
 *  import { loadStripe } from '@stripe/stripe-js';
 *  const stripePromise = loadStripe('STRIPE_PK_KEY');
 *
 * // in the render method call this one like:
 * // <button onClick={this.handleCheckoutClick}>PAY CAMPAIGN</button>
 *
 * handleCheckoutClick = async (event) => {
 * const { campaignID } = this.state;
 * const billingAccess = new BillingAccess()
 *    try {
 *        const { id: sessionId } = await billingAccess.payCampaign(campaignID)
 *        console.log("REPLY FROM BILLING", sessionId)
 *        // When the customer clicks on the button, redirect them to Checkout.
 *        const stripe = await stripePromise;
 *        const { error } = await stripe.redirectToCheckout({
 *            sessionId,
 *        });
 *        if(error) {
 *            // DO SOMETHING WITH STRIPE ERROR
 *        }
 *    } catch (error) {
 *    // DO SOMETHING WITH API THE ERROR
 *    }
 * };
 *
 *
*/

var BillingAccess = function () {
  /**
   *
   * @param {DataLayerConfiguration} options
   * @param {host} [options.hosts = defaults] | An access token
   *
   */
  function BillingAccess(_a) {
    var _b = (_a === void 0 ? {} : _a).hosts,
        hosts = _b === void 0 ? defaults_1.default : _b;
    this._authRenewal = utils_1.tokenRenewal;
    this.auth = new Auth_1.default({
      auth_host: hosts.auth_host
    });
    this.token = this.auth.getToken() || '';
    this.api = new SounditiApi_1.default({
      token: this.token,
      hosts: hosts
    });
    this.table = 'campaigns';
  }

  ;
  /**
   * Initiate the campaignPayment Process
   * the response id should be fetched into a stripe checkout
   * as a sessionID.
   *
   * @param {string} campaignId Campaign uuid
   * @param {string} [code = ""] Promotional code
   * @param {boolean} [useWallet = false] True if the user is using its wallet amount
   * @param {boolean} [renew = true] If true will try to renew accessToken on first PermissionError
   *
   * @returns {Promise<any>}
   *
   * @throws {BillingError} When a user try to paid for a paid|publi campaign
   * @throws {PermissionError} Auth token not valid
   */

  BillingAccess.prototype.payCampaign = function (campaignId, code, useWallet, renew) {
    if (code === void 0) {
      code = "";
    }

    if (useWallet === void 0) {
      useWallet = false;
    }

    if (renew === void 0) {
      renew = true;
    }

    return __awaiter(this, void 0, void 0, function () {
      var res, paymentIntent, paymentIntent, e, error_1;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            _a.trys.push([0, 10,, 11]);

            return [4
            /*yield*/
            , this.api.campaignCheckout(campaignId, code, useWallet)];

          case 1:
            res = _a.sent();
            if (!(res.status === 200)) return [3
            /*break*/
            , 3];
            return [4
            /*yield*/
            , res.json()];

          case 2:
            paymentIntent = _a.sent();
            logger.debug('payment Intent returned', __assign({}, paymentIntent));
            return [2
            /*return*/
            , paymentIntent];

          case 3:
            if (!(res.status === 403 && renew)) return [3
            /*break*/
            , 6];
            return [4
            /*yield*/
            , this._authRenewal()];

          case 4:
            _a.sent();

            return [4
            /*yield*/
            , this.payCampaign(campaignId, code, useWallet, false)];

          case 5:
            paymentIntent = _a.sent();
            return [2
            /*return*/
            , paymentIntent];

          case 6:
            if (!(res.status === 400)) return [3
            /*break*/
            , 8];
            return [4
            /*yield*/
            , res.json()];

          case 7:
            e = _a.sent();
            throw new errors_1.BillingError(e.message);

          case 8:
            throw new errors_1.PermissionError('Invalid access token');

          case 9:
            return [3
            /*break*/
            , 11];

          case 10:
            error_1 = _a.sent();
            throw error_1;

          case 11:
            return [2
            /*return*/
            ];
        }
      });
    });
  };

  ;
  /**
   * Send promotional code to check for apply
   *
   * @param {object} campaign Campaign data
   * @param {string} code Promotional code
   * @param {boolean} [renew = true] If true will try to renew accessToken on first PermissionError
   *
   * @returns {Promise<any>}
   *
   * @throws {BillingError} When a user try to promotional code that do not exist
   * @throws {PermissionError} Auth token not valid
   */

  BillingAccess.prototype.applyPromotionalCode = function (campaign, code, renew) {
    if (renew === void 0) {
      renew = true;
    }

    return __awaiter(this, void 0, void 0, function () {
      var res, promotionalCodeIntent, promotionalCodeIntent, e, error_2;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            _a.trys.push([0, 10,, 11]);

            return [4
            /*yield*/
            , this.api.applyPromotionalCode(campaign, code)];

          case 1:
            res = _a.sent();
            if (!(res.status === 200)) return [3
            /*break*/
            , 3];
            return [4
            /*yield*/
            , res.json()];

          case 2:
            promotionalCodeIntent = _a.sent();
            logger.debug('promotional code Intent returned', __assign({}, promotionalCodeIntent));
            return [2
            /*return*/
            , promotionalCodeIntent];

          case 3:
            if (!(res.status === 403 && renew)) return [3
            /*break*/
            , 6];
            return [4
            /*yield*/
            , this._authRenewal()];

          case 4:
            _a.sent();

            return [4
            /*yield*/
            , this.applyPromotionalCode(campaign, code, false)];

          case 5:
            promotionalCodeIntent = _a.sent();
            return [2
            /*return*/
            , promotionalCodeIntent];

          case 6:
            if (!(res.status === 400)) return [3
            /*break*/
            , 8];
            return [4
            /*yield*/
            , res.json()];

          case 7:
            e = _a.sent();
            throw new errors_1.BillingError(e.message);

          case 8:
            throw new errors_1.PermissionError('Invalid access token');

          case 9:
            return [3
            /*break*/
            , 11];

          case 10:
            error_2 = _a.sent();
            throw error_2;

          case 11:
            return [2
            /*return*/
            ];
        }
      });
    });
  };

  ;
  /**
   * Initiate the recharge wallet proccess
   *
   * @param {UserData} user User data
   * @param {number} amount Amount to recharge
   * @param {boolean} [renew = true] If true will try to renew accessToken on first PermissionError
   *
   * @returns {Promise<any>}
   *
   * @throws {BillingError} When a user try to paid for a wallet
   * @throws {PermissionError} Auth token not valid
   */

  BillingAccess.prototype.rechargeWallet = function (user, amount, renew) {
    if (renew === void 0) {
      renew = true;
    }

    return __awaiter(this, void 0, void 0, function () {
      var res, rechargeWalletIntent, rechargeWalletIntent, e, error_3;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            _a.trys.push([0, 10,, 11]);

            return [4
            /*yield*/
            , this.api.rechargeWallet(user, amount)];

          case 1:
            res = _a.sent();
            if (!(res.status === 200)) return [3
            /*break*/
            , 3];
            return [4
            /*yield*/
            , res.json()];

          case 2:
            rechargeWalletIntent = _a.sent();
            logger.debug('recharge wallet Intent returned', __assign({}, rechargeWalletIntent));
            return [2
            /*return*/
            , rechargeWalletIntent];

          case 3:
            if (!(res.status === 403 && renew)) return [3
            /*break*/
            , 6];
            return [4
            /*yield*/
            , this._authRenewal()];

          case 4:
            _a.sent();

            return [4
            /*yield*/
            , this.rechargeWallet(user, amount, false)];

          case 5:
            rechargeWalletIntent = _a.sent();
            return [2
            /*return*/
            , rechargeWalletIntent];

          case 6:
            if (!(res.status === 400)) return [3
            /*break*/
            , 8];
            return [4
            /*yield*/
            , res.json()];

          case 7:
            e = _a.sent();
            throw new errors_1.BillingError(e.message);

          case 8:
            throw new errors_1.PermissionError('Invalid access token');

          case 9:
            return [3
            /*break*/
            , 11];

          case 10:
            error_3 = _a.sent();
            throw error_3;

          case 11:
            return [2
            /*return*/
            ];
        }
      });
    });
  };

  ;
  /**
   * Upgrades user's subscription
   *
   * @param {UserData} user User data
   * @param {string} subscriptionId id of new subscription
   * @param {boolean} [isYearPaid = false] Indicate if the paid is for full year
   * @param {boolean} [renew = true] If true will try to renew accessToken on first PermissionError
   *
   * @returns {Promise<Stripe.Checkout.Session>}
   *
   * @throws {BillingError} When a user try to paid for a subscription
   * @throws {PermissionError} Auth token not valid
   */

  BillingAccess.prototype.subscriptionUpgrade = function (user, subscriptionId, isYearPaid, renew) {
    if (isYearPaid === void 0) {
      isYearPaid = false;
    }

    if (renew === void 0) {
      renew = true;
    }

    return __awaiter(this, void 0, void 0, function () {
      var res, subscriptionUpgradeIntent, subscriptionUpgradeIntent, e, error_4;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            _a.trys.push([0, 10,, 11]);

            return [4
            /*yield*/
            , this.api.subscriptionUpgrade(user, subscriptionId, isYearPaid)];

          case 1:
            res = _a.sent();
            if (!(res.status === 200)) return [3
            /*break*/
            , 3];
            return [4
            /*yield*/
            , res.json()];

          case 2:
            subscriptionUpgradeIntent = _a.sent();
            logger.debug('subscription upgrade Intent returned', __assign({}, subscriptionUpgradeIntent));
            return [2
            /*return*/
            , subscriptionUpgradeIntent];

          case 3:
            if (!(res.status === 403 && renew)) return [3
            /*break*/
            , 6];
            return [4
            /*yield*/
            , this._authRenewal()];

          case 4:
            _a.sent();

            return [4
            /*yield*/
            , this.subscriptionUpgrade(user, subscriptionId, isYearPaid, false)];

          case 5:
            subscriptionUpgradeIntent = _a.sent();
            return [2
            /*return*/
            , subscriptionUpgradeIntent];

          case 6:
            if (!(res.status === 400)) return [3
            /*break*/
            , 8];
            return [4
            /*yield*/
            , res.json()];

          case 7:
            e = _a.sent();
            throw new errors_1.BillingError(e.message);

          case 8:
            throw new errors_1.PermissionError('Invalid access token');

          case 9:
            return [3
            /*break*/
            , 11];

          case 10:
            error_4 = _a.sent();
            throw error_4;

          case 11:
            return [2
            /*return*/
            ];
        }
      });
    });
  };

  ;
  /**
   * Cancel user's subscription and set it to FREE
   *
   * @param {object} user User data
   * @param {boolean} [renew = true] If true will try to renew accessToken on first PermissionError
   *
   * @returns {string} A message if succcess: "DOWNGRADE_SUCCESS"
   *
   * @throws {BillingError} When a user try to cancel a subscription
   * @throws {PermissionError} Auth token not valid
   */

  BillingAccess.prototype.subscriptionCancel = function (user, renew) {
    if (renew === void 0) {
      renew = true;
    }

    return __awaiter(this, void 0, void 0, function () {
      var res, subscriptionCancelIntent, subscriptionCancelIntent, e, error_5;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            _a.trys.push([0, 10,, 11]);

            return [4
            /*yield*/
            , this.api.subscriptionCancel(user)];

          case 1:
            res = _a.sent();
            if (!(res.status === 200)) return [3
            /*break*/
            , 3];
            return [4
            /*yield*/
            , res.json()];

          case 2:
            subscriptionCancelIntent = _a.sent();
            logger.debug('subscription cancel Intent returned', __assign({}, subscriptionCancelIntent));
            return [2
            /*return*/
            , subscriptionCancelIntent];

          case 3:
            if (!(res.status === 403 && renew)) return [3
            /*break*/
            , 6];
            return [4
            /*yield*/
            , this._authRenewal()];

          case 4:
            _a.sent();

            return [4
            /*yield*/
            , this.subscriptionCancel(user, false)];

          case 5:
            subscriptionCancelIntent = _a.sent();
            return [2
            /*return*/
            , subscriptionCancelIntent];

          case 6:
            if (!(res.status === 400)) return [3
            /*break*/
            , 8];
            return [4
            /*yield*/
            , res.json()];

          case 7:
            e = _a.sent();
            throw new errors_1.BillingError(e.message);

          case 8:
            throw new errors_1.PermissionError('Invalid access token');

          case 9:
            return [3
            /*break*/
            , 11];

          case 10:
            error_5 = _a.sent();
            throw error_5;

          case 11:
            return [2
            /*return*/
            ];
        }
      });
    });
  };

  ;
  /**
   * Checks if the campaign that is going to be published
   * has overuse and returns the overuse details
   *
   * @param {object} user User data
   * @param {object} campaign Campaign data
   * @param {boolean} [renew = true] If true will try to renew accessToken on first PermissionError
   *
   * @returns {Promise<OveruseResponse>} The overuse details
   *
   * @throws {BillingError} When a user try to check the overuse
   * @throws {PermissionError} Auth token not valid
   */

  BillingAccess.prototype.checkOveruse = function (user, campaign, renew) {
    if (renew === void 0) {
      renew = true;
    }

    return __awaiter(this, void 0, void 0, function () {
      var res, checkOveruseIntent, checkOveruseIntent, e, error_6;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            _a.trys.push([0, 10,, 11]);

            return [4
            /*yield*/
            , this.api.checkOveruse(user, campaign)];

          case 1:
            res = _a.sent();
            if (!(res.status === 200)) return [3
            /*break*/
            , 3];
            return [4
            /*yield*/
            , res.json()];

          case 2:
            checkOveruseIntent = _a.sent();
            logger.debug('check overuse Intent returned', __assign({}, checkOveruseIntent));
            return [2
            /*return*/
            , checkOveruseIntent];

          case 3:
            if (!(res.status === 403 && renew)) return [3
            /*break*/
            , 6];
            return [4
            /*yield*/
            , this._authRenewal()];

          case 4:
            _a.sent();

            return [4
            /*yield*/
            , this.checkOveruse(user, campaign, false)];

          case 5:
            checkOveruseIntent = _a.sent();
            return [2
            /*return*/
            , checkOveruseIntent];

          case 6:
            if (!(res.status === 400)) return [3
            /*break*/
            , 8];
            return [4
            /*yield*/
            , res.json()];

          case 7:
            e = _a.sent();
            throw new errors_1.BillingError(e.message);

          case 8:
            throw new errors_1.PermissionError('Invalid access token');

          case 9:
            return [3
            /*break*/
            , 11];

          case 10:
            error_6 = _a.sent();
            throw error_6;

          case 11:
            return [2
            /*return*/
            ];
        }
      });
    });
  };

  ;
  /**
   * Charges a previously saved credit card
   * with the price of the campaign
   *
   * @param {string} campaignId campaign to be published
   * @param {string} cardId stripe cardId uuid
   * @param {boolean} [renew = true] If true will try to renew accessToken on first PermissionError
   *
   * @returns {Promise<Stripe.Response<Stripe.PaymentIntent>>}
   *
   * @throws {BillingError} When a user try to paid for a paid|publi campaign
   * @throws {PermissionError} Auth token not valid
   */

  BillingAccess.prototype.chargeUserForACampaign = function (campaignId, cardId, renew) {
    if (renew === void 0) {
      renew = true;
    }

    return __awaiter(this, void 0, void 0, function () {
      var res, paymentIntent, paymentIntent, e, error_7;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            _a.trys.push([0, 10,, 11]);

            return [4
            /*yield*/
            , this.api.chargeUserForCampaign(campaignId, cardId)];

          case 1:
            res = _a.sent();
            if (!(res.status === 200)) return [3
            /*break*/
            , 3];
            return [4
            /*yield*/
            , res.json()];

          case 2:
            paymentIntent = _a.sent();
            logger.debug('payment Intent returned', __assign({}, paymentIntent));
            return [2
            /*return*/
            , paymentIntent];

          case 3:
            if (!(res.status === 403 && renew)) return [3
            /*break*/
            , 6];
            return [4
            /*yield*/
            , this._authRenewal()];

          case 4:
            _a.sent();

            return [4
            /*yield*/
            , this.chargeUserForACampaign(campaignId, cardId, false)];

          case 5:
            paymentIntent = _a.sent();
            return [2
            /*return*/
            , paymentIntent];

          case 6:
            if (!(res.status === 400)) return [3
            /*break*/
            , 8];
            return [4
            /*yield*/
            , res.json()];

          case 7:
            e = _a.sent();
            throw new errors_1.BillingError(e.message);

          case 8:
            throw new errors_1.PermissionError('Invalid access token');

          case 9:
            return [3
            /*break*/
            , 11];

          case 10:
            error_7 = _a.sent();
            throw error_7;

          case 11:
            return [2
            /*return*/
            ];
        }
      });
    });
  };

  ;
  /**
   * Publish a campaign taking into account the user quota free tier quota and type normal|premium|super
   *
   * @param {string} campaignId Campaign uuid
   * @param {boolean} [renew = true] If true will try to renew accessToken on first PermissionError
   *
   * @returns {PublishResult} Result of the publish intent
   *
   * @throws {BillingError} When a user try to publish a campaign in a status that is neither draft or preview
   * @throws {PermissionError} Auth token not valid
   */

  BillingAccess.prototype.publishCampaign = function (campaignId, renew) {
    if (renew === void 0) {
      renew = true;
    }

    return __awaiter(this, void 0, void 0, function () {
      var res, paymentIntent, paymentIntent, e, error_8;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            _a.trys.push([0, 10,, 11]);

            return [4
            /*yield*/
            , this.api.publishCampaign(campaignId)];

          case 1:
            res = _a.sent();
            if (!(res.status === 200)) return [3
            /*break*/
            , 3];
            return [4
            /*yield*/
            , res.json()];

          case 2:
            paymentIntent = _a.sent();
            logger.debug('publish Campaign Intent returned', __assign({}, paymentIntent));
            return [2
            /*return*/
            , paymentIntent];

          case 3:
            if (!(res.status === 403 && renew)) return [3
            /*break*/
            , 6];
            return [4
            /*yield*/
            , this._authRenewal()];

          case 4:
            _a.sent();

            return [4
            /*yield*/
            , this.publishCampaign(campaignId, false)];

          case 5:
            paymentIntent = _a.sent();
            return [2
            /*return*/
            , paymentIntent];

          case 6:
            if (!(res.status === 400)) return [3
            /*break*/
            , 8];
            return [4
            /*yield*/
            , res.json()];

          case 7:
            e = _a.sent();
            throw new errors_1.BillingError(e.message);

          case 8:
            throw new errors_1.PermissionError('Invalid access token');

          case 9:
            return [3
            /*break*/
            , 11];

          case 10:
            error_8 = _a.sent();
            throw error_8;

          case 11:
            return [2
            /*return*/
            ];
        }
      });
    });
  };

  ;
  /**
   * Publish a campaign taking into account the user quota free tier quota and type normal|premium|super using a promotional code
   *
   * @param {string} campaignId Campaign uuid
   * @param {string} [code = ""] Promotional code
   * @param {boolean} [useWallet = false] True if the user is using its wallet amount
   * @param {boolean} [renew = false] If true will try to renew accessToken on first PermissionError
   *
   * @returns {PublishResult} Result of the publish intent
   *
   * @throws {BillingError} When a user try to publish a campaign in a status that is neither draft or preview
   * @throws {PermissionError} Auth token not valid
   */

  BillingAccess.prototype.publishCampaignWithPromotionalCode = function (campaignId, code, useWallet, renew) {
    if (code === void 0) {
      code = "";
    }

    if (useWallet === void 0) {
      useWallet = false;
    }

    if (renew === void 0) {
      renew = true;
    }

    return __awaiter(this, void 0, void 0, function () {
      var res, paymentIntent, paymentIntent, e, error_9;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            _a.trys.push([0, 10,, 11]);

            return [4
            /*yield*/
            , this.api.publishCampaignWithPromotionalCode(campaignId, code, useWallet)];

          case 1:
            res = _a.sent();
            if (!(res.status === 200)) return [3
            /*break*/
            , 3];
            return [4
            /*yield*/
            , res.json()];

          case 2:
            paymentIntent = _a.sent();
            logger.debug('payment Intent returned', __assign({}, paymentIntent));
            return [2
            /*return*/
            , paymentIntent];

          case 3:
            if (!(res.status === 403 && renew)) return [3
            /*break*/
            , 6];
            return [4
            /*yield*/
            , this._authRenewal()];

          case 4:
            _a.sent();

            return [4
            /*yield*/
            , this.publishCampaignWithPromotionalCode(campaignId, code, useWallet, false)];

          case 5:
            paymentIntent = _a.sent();
            return [2
            /*return*/
            , paymentIntent];

          case 6:
            if (!(res.status === 400)) return [3
            /*break*/
            , 8];
            return [4
            /*yield*/
            , res.json()];

          case 7:
            e = _a.sent();
            throw new errors_1.BillingError(e.message);

          case 8:
            throw new errors_1.PermissionError('Invalid access token');

          case 9:
            return [3
            /*break*/
            , 11];

          case 10:
            error_9 = _a.sent();
            throw error_9;

          case 11:
            return [2
            /*return*/
            ];
        }
      });
    });
  };

  ;
  /**
   * Retrieves charges from stripe api
   *
   * @todo sounditi api endpoint to call the stripe api with the secrete key
   * @todo add stripe customer data to user When making a payment ==> update webhook to update user
   *
   * @param {boolean} [renew = false] If true will try to renew accessToken on first PermissionError
   *
   * @returns {Promise<SndStripeCharge[]>} A list of stripe charges
   *
   * @throws {BillingError} When an error occurs getting the charges
   * @throws {PermissionError} Auth token not valid
   */

  BillingAccess.prototype.getCharges = function (renew) {
    if (renew === void 0) {
      renew = true;
    }

    return __awaiter(this, void 0, void 0, function () {
      var res, cards, cards, e, error_10;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            _a.trys.push([0, 10,, 11]);

            return [4
            /*yield*/
            , this.api.getUserCharges()];

          case 1:
            res = _a.sent();
            if (!(res.status === 200)) return [3
            /*break*/
            , 3];
            return [4
            /*yield*/
            , res.json()];

          case 2:
            cards = _a.sent();
            return [2
            /*return*/
            , cards];

          case 3:
            if (!(res.status === 403 && renew)) return [3
            /*break*/
            , 6];
            return [4
            /*yield*/
            , this._authRenewal()];

          case 4:
            _a.sent();

            return [4
            /*yield*/
            , this.getCharges(false)];

          case 5:
            cards = _a.sent();
            return [2
            /*return*/
            , cards];

          case 6:
            if (!(res.status === 400)) return [3
            /*break*/
            , 8];
            return [4
            /*yield*/
            , res.json()];

          case 7:
            e = _a.sent();
            throw new errors_1.BillingError(e.message);

          case 8:
            throw new errors_1.PermissionError('Invalid access token');

          case 9:
            return [3
            /*break*/
            , 11];

          case 10:
            error_10 = _a.sent();
            throw error_10;

          case 11:
            return [2
            /*return*/
            ];
        }
      });
    });
  };

  ;
  /**
   * Retrieves a subscription list
   *
   * @param {boolean} [renew = false] If true will try to renew accessToken on first PermissionError
   *
   * @returns {Promise<Subscription[]>} A list of stripe charges
   *
   * @throws {BillingError} When an error occurs getting the subscriptions list
   * @throws {PermissionError} Auth token not valid
   */

  BillingAccess.prototype.getSubscriptionList = function (renew) {
    if (renew === void 0) {
      renew = true;
    }

    return __awaiter(this, void 0, void 0, function () {
      var res, subs, subs, e, error_11;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            _a.trys.push([0, 10,, 11]);

            return [4
            /*yield*/
            , this.api.getSubscriptionList()];

          case 1:
            res = _a.sent();
            if (!(res.status === 200)) return [3
            /*break*/
            , 3];
            return [4
            /*yield*/
            , res.json()];

          case 2:
            subs = _a.sent();
            return [2
            /*return*/
            , subs];

          case 3:
            if (!(res.status === 403 && renew)) return [3
            /*break*/
            , 6];
            return [4
            /*yield*/
            , this._authRenewal()];

          case 4:
            _a.sent();

            return [4
            /*yield*/
            , this.getSubscriptionList(false)];

          case 5:
            subs = _a.sent();
            return [2
            /*return*/
            , subs];

          case 6:
            if (!(res.status === 400)) return [3
            /*break*/
            , 8];
            return [4
            /*yield*/
            , res.json()];

          case 7:
            e = _a.sent();
            throw new errors_1.BillingError(e.message);

          case 8:
            throw new errors_1.PermissionError('Invalid access token');

          case 9:
            return [3
            /*break*/
            , 11];

          case 10:
            error_11 = _a.sent();
            throw error_11;

          case 11:
            return [2
            /*return*/
            ];
        }
      });
    });
  };

  ;
  /**
   * Retrieves saved credit cards from stripe api
   *
   * @param {boolean} [renew = false] If true will try to renew accessToken on first PermissionError
   *
   * @returns {Promise<Stripe.PaymentMethod[]>} A list of stripe cards
   *
   * @throws {BillingError} When an error occurs getting the credit cards
   * @throws {PermissionError} Auth token not valid
   */

  BillingAccess.prototype.getCreditCards = function (renew) {
    if (renew === void 0) {
      renew = true;
    }

    return __awaiter(this, void 0, void 0, function () {
      var res, cards, cards, e, error_12;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            _a.trys.push([0, 10,, 11]);

            return [4
            /*yield*/
            , this.api.getUserCards()];

          case 1:
            res = _a.sent();
            if (!(res.status === 200)) return [3
            /*break*/
            , 3];
            return [4
            /*yield*/
            , res.json()];

          case 2:
            cards = _a.sent();
            return [2
            /*return*/
            , cards];

          case 3:
            if (!(res.status === 403 && renew)) return [3
            /*break*/
            , 6];
            return [4
            /*yield*/
            , this._authRenewal()];

          case 4:
            _a.sent();

            return [4
            /*yield*/
            , this.getCreditCards(false)];

          case 5:
            cards = _a.sent();
            return [2
            /*return*/
            , cards];

          case 6:
            if (!(res.status === 400)) return [3
            /*break*/
            , 8];
            return [4
            /*yield*/
            , res.json()];

          case 7:
            e = _a.sent();
            throw new errors_1.BillingError(e.message);

          case 8:
            throw new errors_1.PermissionError('Invalid access token');

          case 9:
            return [3
            /*break*/
            , 11];

          case 10:
            error_12 = _a.sent();
            throw error_12;

          case 11:
            return [2
            /*return*/
            ];
        }
      });
    });
  };

  ;
  /**
   * Retrieves a SetupIntent to save a credit card in stripe
   *
   * @param {boolean} [renew = false] If true will try to renew accessToken on first PermissionError
   *
   * @returns {Promise<string>} Saved card message
   *
   * @throws {BillingError} When an error occurs saving the credit card
   * @throws {PermissionError} Auth token not valid
   */

  BillingAccess.prototype.saveCreditCard = function (renew) {
    if (renew === void 0) {
      renew = true;
    }

    return __awaiter(this, void 0, void 0, function () {
      var res, cards, cards, e, error_13;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            _a.trys.push([0, 10,, 11]);

            return [4
            /*yield*/
            , this.api.postUserCard()];

          case 1:
            res = _a.sent();
            if (!(res.status === 200)) return [3
            /*break*/
            , 3];
            return [4
            /*yield*/
            , res.json()];

          case 2:
            cards = _a.sent();
            return [2
            /*return*/
            , cards];

          case 3:
            if (!(res.status === 403 && renew)) return [3
            /*break*/
            , 6];
            return [4
            /*yield*/
            , this._authRenewal()];

          case 4:
            _a.sent();

            return [4
            /*yield*/
            , this.saveCreditCard(false)];

          case 5:
            cards = _a.sent();
            return [2
            /*return*/
            , cards];

          case 6:
            if (!(res.status === 400)) return [3
            /*break*/
            , 8];
            return [4
            /*yield*/
            , res.json()];

          case 7:
            e = _a.sent();
            throw new errors_1.BillingError(e.message);

          case 8:
            throw new errors_1.PermissionError('Invalid access token');

          case 9:
            return [3
            /*break*/
            , 11];

          case 10:
            error_13 = _a.sent();
            throw error_13;

          case 11:
            return [2
            /*return*/
            ];
        }
      });
    });
  };

  ;
  /**
   * Retrieves a SetupIntent to save a credit card in stripe
   *
   * @param {boolean} [renew = false] If true will try to renew accessToken on first PermissionError
   *
   * @returns {Promise<string>} Saved card message
   *
   * @throws {BillingError} When an error occurs saving the credit card
   * @throws {PermissionError} Auth token not valid
   */

  BillingAccess.prototype.payAudience = function (payAudienceRequest, renew) {
    if (renew === void 0) {
      renew = true;
    }

    return __awaiter(this, void 0, void 0, function () {
      var res, cards, cards, e, error_14;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            _a.trys.push([0, 10,, 11]);

            return [4
            /*yield*/
            , this.api.payAudience(payAudienceRequest)];

          case 1:
            res = _a.sent();
            if (!(res.status === 200)) return [3
            /*break*/
            , 3];
            return [4
            /*yield*/
            , res.json()];

          case 2:
            cards = _a.sent();
            return [2
            /*return*/
            , cards];

          case 3:
            if (!(res.status === 403 && renew)) return [3
            /*break*/
            , 6];
            return [4
            /*yield*/
            , this._authRenewal()];

          case 4:
            _a.sent();

            return [4
            /*yield*/
            , this.payAudience(payAudienceRequest, false)];

          case 5:
            cards = _a.sent();
            return [2
            /*return*/
            , cards];

          case 6:
            if (!(res.status === 400)) return [3
            /*break*/
            , 8];
            return [4
            /*yield*/
            , res.json()];

          case 7:
            e = _a.sent();
            throw new errors_1.BillingError(e.message);

          case 8:
            throw new errors_1.PermissionError('Invalid access token');

          case 9:
            return [3
            /*break*/
            , 11];

          case 10:
            error_14 = _a.sent();
            throw error_14;

          case 11:
            return [2
            /*return*/
            ];
        }
      });
    });
  };

  ;
  return BillingAccess;
}();

;
exports.default = BillingAccess;